import styled from "styled-components";

export const HomeEditorsChoiceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
`;
